<template>
  <div class="delivery">
    <headd :mobile_title="mobile_title"></headd>
    <div class="form container">
      <div class="f_title hidden-sm hidden-xs">立即寄送</div>
      <div class="f_cell" style="width:100%;">
        <div class="cell_title">物品详细</div>
        <div class="cell_vaule">
          <textarea
            class="textarea"
            type="text"
            placeholder="请输入您的物品详情"
            v-model="Express.itemdesc"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">寄件人</div>
        <div class="cell_vaule">
          <input
            class="input"
            type="text"
            placeholder="请输入寄件人姓名"
            v-model="Express.sender"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">电话号码</div>
        <div class="cell_vaule">
          <input
            class="input"
            type="tel"
            placeholder="请输入寄件人的电话号码"
            v-model="Express.sender_tel"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">寄件地址</div>
        <div class="cell_vaule">
          <input
            class="input"
            type="text"
            placeholder="请输入地址"
            v-model="Express.sender_address"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">收件人</div>
        <div class="cell_vaule">
          <input
            class="input"
            type="text"
            placeholder="请输入收件人姓名"
            v-model="Express.recipient"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">电话号码</div>
        <div class="cell_vaule">
          <input
            class="input"
            type="tel"
            placeholder="请输入收件人的电话号码"
            v-model="Express.recipient_tel"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">收件地址</div>
        <div class="cell_vaule">
          <input
            class="input"
            type="text"
            placeholder="请输入收件地址"
            v-model="Express.recipient_address"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">快递公司</div>
        <div class="cell_vaule">
          <input
            class="input"
            type="text"
            placeholder="请输入快递公司"
            v-model="Express.express_company"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">快递单号</div>
        <div class="cell_vaule">
          <input
            class="input"
            type="text"
            placeholder="请输入快递单号"
            v-model="Express.express_no"
          />
        </div>
      </div>
      <div class="f_cell">
        <div class="cell_title">快递费</div>
        <div class="cell_vaule">
          <input
            class="input"
            type="number"
            placeholder="请输入快递费金额"
            v-model="Express.express_price"
          />
        </div>
      </div>
    </div>
    <div class="btn_save_red" @click="btn_save">提交</div>
    <foot></foot>
  </div>
</template>

<script>
import headd from "@/components/head";
import foot from "@/components/foot";
import { getitemExpress } from "../api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      mobile_title: "立即寄送",
      Express: {
        itemdesc: "",
        sender: "",
        sender_tel: "",
        sender_address: "",
        recipient: "",
        recipient_tel: "",
        recipient_address: "",
        express_company: "",
        express_no: "",
        express_price: ""
      }
    };
  },
  components: {
    headd,
    foot
  },
  methods: {
    async btn_save() {
      var _self = this;
      console.log(_self.Express);
      _self.Express.uid = localStorage.getItem("userId");
      var data = _self.Express;
      if (data.itemdesc == "") {
        this.$toast("请输入物品详细");

        return false;
      }
      if (data.sender == "") {
        this.$toast("请输入寄件人");

        return false;
      }
      if (data.sender_tel == "") {
        this.$toast("请输入寄件人电话");

        return false;
      }
      if (data.sender_address == "") {
        this.$toast("请输入寄件人地址");

        return false;
      }
      if (data.recipient == "") {
        this.$toast("请输入收件人");

        return false;
      }
      if (data.recipient_tel == "") {
        this.$toast("请输入收件人电话");

        return false;
      }
      if (data.recipient_address == "") {
        this.$toast("请输入收件人地址");

        return false;
      }
      if (data.express_company == "") {
        this.$toast("请输入快递公司");

        return false;
      }
      if (data.express_no == "") {
        this.$toast("请输入快递单号");

        return false;
      }
      if (data.express_price == "") {
        this.$toast("请输入快递费");

        return false;
      }
      const res = await getitemExpress(data);
      if (res.status == 1) {
        this.$toast({
          message: "提交成功",
          type: "success"
        });
        _self.Express = {
          itemdesc: "",
          sender: "",
          sender_tel: "",
          sender_address: "",
          recipient: "",
          recipient_tel: "",
          recipient_address: "",
          express_company: "",
          express_no: "",
          express_price: ""
        };
        this.$router.push({
          path: "deliverylist"
        });
      }
    }
  }
};
</script>

<style lang="less">
.delivery {
  margin: 0 auto;
  flex-direction: column;
  text-align: left;
  border-top: 0.02rem solid #f5f5f5;
  .form {
    width: 10rem;
    @media (max-width: 991px) {
      width: 6.86rem;
      padding: 0;
      margin-top: 0.32rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/delivery/adddelivery.vue